import React, { useState } from "react";

import { CopyIcon } from "@chakra-ui/icons";
import { Flex, Divider, Text, Button, HStack, useToast } from "@chakra-ui/react";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { Popover, PopoverTrigger, PopoverContent, PopoverBody, PopoverArrow } from "@chakra-ui/react";
import { useClipboard } from "@chakra-ui/react";
import { BiError } from "react-icons/bi";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { callApiWithToken } from "../../../utils/http_common";

const MerchantKeyUpdateModal = ({ isOpen, onClose }) => {
  const { onCopy } = useClipboard();
  const toast = useToast();

  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(null);

  const onCloseModal = () => {
    onClose();
    setAgree(false);
  };

  const onClickGenerate = async () => {
    setLoading(true);
    try {
      const response = await callApiWithToken.patch("/setting/merchant-key");
      setPassword(response.data.data.merchantKey);
      setAgree(true);
    } catch (error) {
      console.log(error);
      // toast some error message
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      onClose();
    }
    setLoading(false);
  };

  return (
    <>
      {!agree ? (
        <Modal isOpen={isOpen} onClose={onCloseModal} size="xl" isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader m={0} p={0}>
              <div className="w-full bg-red-500 h-[50px] flex items-center justify-center text-white">Be Careful!</div>
            </ModalHeader>
            <Divider />
            <ModalBody>
              <div className="flex flex-col gap-4 justify-center items-center">
                <BiError className="text-red-500 w-20 h-20" />
                <Text className="text-center">
                  Are you sure you want to re-generate the API passphrase of read only credentials? After doing this action the old key will be immediately
                  discarded and it cannot be used again. If you don’t have the API Passphrase, or if it is the first time you will use it, re-generating is a
                  safe operation.
                </Text>
              </div>
            </ModalBody>
            <Divider />
            <ModalFooter>
              <HStack gap="5">
                <Button
                  variant={"solid"}
                  bg={"red.600"}
                  _hover={{ bg: "red.700" }}
                  color="white"
                  size="md"
                  rounded={"10px"}
                  onClick={onClickGenerate}
                  disabled={loading}
                >
                  Yes Generate
                </Button>
                <Button onClick={onCloseModal} border={"1px"} rounded={"10px"} _hover={{ bg: "blue", textColor: "white" }} disabled={loading}>
                  No Stop
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      ) : (
        <Modal isOpen={isOpen} onClose={onCloseModal} size="xl" isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader m={0} p={0}>
              <div className="w-full bg-blue-500 h-[50px] flex items-center justify-center text-white">API password credentials generated</div>
            </ModalHeader>
            <Divider />
            <ModalBody>
              <div className="flex flex-row gap-4 items-center border border-yellow-500 p-4 rounded-md my-4">
                <BiError className="text-yellow-500 w-16 h-16" />
                <Text className="text-center">
                  This is the ONLY time that the API passphrase can be viewed or copied. You cannot recover it later. However, you can re-generate it at any
                  time.
                </Text>
              </div>
              <Divider />
              <TableContainer>
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th width={"80%"}>Api Password</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>{showPassword ? password : "**************************************"}</Td>
                      <Td>
                        <Flex>
                          <Button m={0} p={0} bg={"transparent"} height={"max-content"} onClick={() => setShowPassword((p) => !p)}>
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                          </Button>

                          <Popover>
                            <PopoverTrigger>
                              <Button m={0} p={0} bg={"transparent"} height={"max-content"} onClick={() => onCopy(password)}>
                                <CopyIcon />
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent width={"fit-content"}>
                              <PopoverArrow />
                              <PopoverBody>Copied</PopoverBody>
                            </PopoverContent>
                          </Popover>
                        </Flex>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </ModalBody>
            <Divider />
            <ModalFooter>
              <HStack gap="5">
                <Button
                  variant={"primary"}
                  bg={"#1A4FD6"}
                  _hover={{ bg: "#366cf5" }}
                  color="white"
                  size="md"
                  width={"122px"}
                  height={"46px"}
                  rounded={"10px"}
                  onClick={onCloseModal}
                >
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default MerchantKeyUpdateModal;
